import * as React from "react";
import Button from "@material-ui/core/Button";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import Component from "../../../../AbstractComponent";
import TextField from "../../../../Partials/Material/TextField";
// import TypeContainer from "../../../../../Entity/Entities/Charge/Type/TypeContainer";

import BillDetails from "./BillDetails";
import { calculateBilledMonthFromDates } from "../utils/calculateBilledMonthFromDates";
import { datesToMonthlyPeriods } from "../utils/datesToMonthlyPeriods";
import { getIntersectingPeriod } from "../utils/getIntersectingPeriod";

class Unit extends Component {
  public state = {
    loading: false,
    isNextDisabled: false,
    distributionKeys: {},

    errors: {
      distributionKeys: null,
    },
  };

  constructor(public props) {
    super(props);

    this.state = {
      loading: false,
      isNextDisabled: false,
      distributionKeys: this.props.state.distributionKeys ?? {},
      errors: {
        distributionKeys: null,
      },
    };

    this.update_unit_distribution_key = this.update_unit_distribution_key.bind(this);
    this.doUnitCalculations = this.doUnitCalculations.bind(this);
    this.onNextStep = this.onNextStep.bind(this);
    this.onBack = this.onBack.bind(this);
    this.contractPeriodIntersectsWithBillPeriod = this.contractPeriodIntersectsWithBillPeriod.bind(this);
  }

  public update_unit_distribution_key = (
    unit_id: string | number,
    value: number
  ) => {
    const distributionKeys = this.state.distributionKeys;
    distributionKeys[unit_id] = value;
    this.setState({
      ...this.state,
      distributionKeys,
    });
  };

  public contractPeriodIntersectsWithBillPeriod = (contract, billPeriod) => {
    const period = getIntersectingPeriod(
      { 
        firstDate: contract.contractFirstDate, 
        lastDate: contract.contractLastDate 
      }, 
      billPeriod);
    const IsIntersected = !!period;

    if (IsIntersected) {
      contract.periodIntersectingWithBill = period;
    }

    return IsIntersected;
  }

  public doUnitCalculations() {
    const unit_calculations: Record<string, any> = {};

    const distributionKeys = this.state.distributionKeys;

    //  calculate the total distribution keys
    const totalDistributionKeys = this.props.state.address.units.reduce(
      (acc, unit) => {
        return acc + (distributionKeys[unit.id] ?? 0);
      },
      0
    );

    // calculate the unit percentages
    const unit_percentages = Object.entries(distributionKeys).reduce(
      (acc, [key, value]) => {
        acc[key] = Number(value) / totalDistributionKeys;
        return acc;
      },
      {}
    );

    const units = this.props.state.address?.units || [];

    // find contracts intersecting with bill time interval

    const intersecting_contracts_by_unit = units.reduce(
      (acc, unit) => (
        {
          ...acc,
          [unit.id]: (unit.contracts || []).filter(
            (contract) => this.contractPeriodIntersectsWithBillPeriod(
              contract,
              {
                firstDate: this.props.state.periodFirst,
                lastDate: this.props.state.periodLast,
              }
            ),
          ),
        }
      ),
      {}
    );

    const intersecting_contracts = units
      .map((unit) => intersecting_contracts_by_unit[unit.id] || [])
      .flat();

    const tenants = intersecting_contracts
      .map((contract) => contract.tenant)
      .filter(
        (tenant, idx, arr: any[]) =>
          tenant != null && arr.findIndex((t) => t.id === tenant.id) === idx
      );

    const tenants_by_unit = units.reduce(
      (acc, unit) => ({
        ...acc,
        [unit.id]: intersecting_contracts_by_unit[unit.id]
          .map((contract) => contract.tenant)
          .filter(
            (tenant, idx, arr) =>
              !!tenant && arr.findIndex((t) => t.id === tenant.id) === idx
          ),
      }),
      {}
    );

    const contracts_by_tenant = intersecting_contracts.reduce(
      (acc, contract) => {
        if (!acc[contract.tenant.id]) acc[contract.tenant.id] = [];
        acc[contract.tenant.id].push(contract);
        return acc;
      },
      {}
    );

    const to_pay_by_contracts = intersecting_contracts.reduce(
      (acc, contract) => {
        if (!acc[contract.id]) acc[contract.id] = 0;
        acc[contract.id] += 
            calculateBilledMonthFromDates( // JB: why not use billed_months_by_contract ?
              getIntersectingPeriod(
                { 
                  firstDate: contract.contractFirstDate, 
                  lastDate: contract.contractLastDate 
                },
                {
                  firstDate: this.props.state.periodFirst,
                  lastDate: this.props.state.periodLast,
                }
              )
            ) *
            unit_percentages[contract.unitId] *
            this.props.state.bill_calculations.monthly_payment
          return acc;
      },
      {}
    );

    const getIntersectingChargetemplatesForContractAndBillPeriod = (contract) => {
      return contract.chargeTemplates.filter(
        (charge_template) =>
          charge_template.type.id === this.props.state.chargeTypeForLandlord.utilityBill.id &&
        charge_template.repeatPeriod?.label === "monthly" &&
        !!getIntersectingPeriod(
          getIntersectingPeriod(
            {
              firstDate: charge_template.firstDate,
              lastDate: charge_template.endDate,
            },
            {
              firstDate: contract.contractFirstDate,
              lastDate: contract.contractLastDate,
            }
          ),
          {
            firstDate: this.props.state.periodFirst,
            lastDate: this.props.state.periodLast,
          }
        )
      );
    }

    const charges_templates_by_contract = intersecting_contracts.reduce(
      (acc, contract) => (
        {
          ...acc,
          [contract.id]: getIntersectingChargetemplatesForContractAndBillPeriod(contract),
        }
      ),
      {},
    );

    const billed_months_by_contract = intersecting_contracts.reduce(
      (acc, contract) => {
        if (!acc[contract.id]) acc[contract.id] = 0;
        acc[contract.id] += calculateBilledMonthFromDates(
          getIntersectingPeriod(
            { 
              firstDate: contract.contractFirstDate, 
              lastDate: contract.contractLastDate },
            {
              firstDate: this.props.state.periodFirst,
              lastDate: this.props.state.periodLast,
            }
          )
        );
        return acc;
      },
      {}
    );

    const billed_months_charges_by_contract = intersecting_contracts.reduce(
      (contracts_acc, contract) => ({
        ...contracts_acc,
        [contract.id]: charges_templates_by_contract[contract.id].reduce(
          (charges_acc, charge_template) => ({
            ...charges_acc,
            [charge_template.id]: calculateBilledMonthFromDates(
              getIntersectingPeriod(
                getIntersectingPeriod(
                  {
                    firstDate: charge_template.firstDate,
                    lastDate: charge_template.endDate,
                  },
                  {
                    firstDate: contract.contractFirstDate,
                    lastDate: contract.contractLastDate,
                  }
                ),
                {
                  firstDate: this.props.state.periodFirst,
                  lastDate: this.props.state.periodLast,
                }
              )
            ),
          }),
          {}
        ),
      }),
      {}
    );

    const to_pay_by_units = units.reduce(
      (units_acc, unit) => ({
        ...units_acc,
        [unit.id]: intersecting_contracts_by_unit[unit.id].reduce(
          (contracts_acc, contract) =>
            contracts_acc +
            calculateBilledMonthFromDates( // JB: why not use billed_months_by_contract ?
              getIntersectingPeriod(
                { 
                  firstDate: contract.contractFirstDate, 
                  lastDate: contract.contractLastDate },
                {
                  firstDate: this.props.state.periodFirst,
                  lastDate: this.props.state.periodLast,
                }
              )
            ) *
              unit_percentages[unit.id] *
              this.props.state.bill_calculations.monthly_payment,
          0
        ),
      }),
      {}
    );

    const deposited_by_units = units.reduce(
      (units_acc, unit) => ({
        ...units_acc,
        [unit.id]: intersecting_contracts_by_unit[unit.id].reduce(
          (contracts_acc, contract) =>
            contracts_acc +
            charges_templates_by_contract[contract.id].reduce(
              (charges_acc, charge_template) =>
                charges_acc +
                (charge_template.amount *
                  billed_months_charges_by_contract[contract.id][charge_template.id]) /
                  100,
              0
            ),
          0
        ),
      }),
      {}
    );

    const to_pay_by_units_by_tenants = units.reduce(
      (units_acc, unit) => ({
        ...units_acc,
        [unit.id]: tenants.reduce(
          (tenants_acc, tenant) => ({
            ...tenants_acc,
            [tenant.id]: contracts_by_tenant[tenant.id].reduce(
              (contracts_acc, contract) =>
                contracts_acc +
                calculateBilledMonthFromDates( // JB: why not use billed_months_by_contract ?
                  getIntersectingPeriod(
                    { 
                      firstDate: contract.contractFirstDate, 
                      lastDate: contract.contractLastDate },
                    {
                      firstDate: this.props.state.periodFirst,
                      lastDate: this.props.state.periodLast,
                    }
                  )
                ) *
                  unit_percentages[unit.id] * // JB: why not use to_pay_by_units ?
                  this.props.state.bill_calculations.monthly_payment,
              0
            ),
          }),
          {}
        ),
      }),
      {}
    );

    const deposited_by_units_by_tenants = units.reduce(
      (units_acc, unit) => ({
        ...units_acc,
        [unit.id]: tenants.reduce(
          (tenants_acc, tenant) => ({
            ...tenants_acc,
            [tenant.id]: contracts_by_tenant[tenant.id].reduce(
              (contracts_acc, contract) =>
                contracts_acc + charges_templates_by_contract[contract.id].reduce(
                  (charges_acc, charge_template) => charges_acc + (charge_template.amount * billed_months_charges_by_contract[contract.id][charge_template.id]) / 100, 0
                ), 0
            ),
          }), {}
        ),
      }), {}
    );

    const periods_by_contract = intersecting_contracts.reduce(
      (acc, contract) => ({
        ...acc,
        [contract.id]: datesToMonthlyPeriods(
          getIntersectingPeriod(
            { 
              firstDate: contract.contractFirstDate, 
              lastDate: contract.contractLastDate 
            },
            { 
              firstDate: this.props.state.periodFirst,
              lastDate: this.props.state.periodLast, 
            }
          )
        ).map((period) => ({
          ...period,
          billed_months: calculateBilledMonthFromDates(period),
          deposited: charges_templates_by_contract[contract.id].reduce(
            (acc, charge_template) => acc + (charge_template.amount * calculateBilledMonthFromDates(period)) / 100, 0 
          ),
          to_pay: calculateBilledMonthFromDates(period) * unit_percentages[contract.unit.id] * this.props.state.bill_calculations.monthly_payment,
        })),
      }), {}
    );

    const periods_by_tenant = intersecting_contracts.reduce(
      (acc, contract) => {
          if (!acc[contract.tenant.id]) acc[contract.tenant.id] = [];
          acc[contract.tenant.id].push(...periods_by_contract[contract.id]);
          return acc;
        }, {}
    );

    unit_calculations.totalDistributionKeys = totalDistributionKeys;
    unit_calculations.unit_percentages = unit_percentages;
    unit_calculations.units = units;
    unit_calculations.intersecting_contracts = intersecting_contracts;
    unit_calculations.tenants = tenants;
    //
    unit_calculations.intersecting_contracts_by_unit = intersecting_contracts_by_unit;
    unit_calculations.tenants_by_unit = tenants_by_unit;
    unit_calculations.contracts_by_tenant = contracts_by_tenant;
    unit_calculations.to_pay_by_contracts = to_pay_by_contracts;    
    unit_calculations.charges_by_contract = charges_templates_by_contract;
    unit_calculations.billed_months_by_contract = billed_months_by_contract;
    unit_calculations.billed_months_charges_by_contract = billed_months_charges_by_contract;
    unit_calculations.to_pay_by_units = to_pay_by_units;
    unit_calculations.deposited_by_units = deposited_by_units;
    unit_calculations.to_pay_by_units_by_tenants = to_pay_by_units_by_tenants;
    unit_calculations.deposited_by_units_by_tenants = deposited_by_units_by_tenants;
    unit_calculations.periods_by_contract = periods_by_contract;
    unit_calculations.periods_by_tenant = periods_by_tenant;
    
    return unit_calculations;
  }

  public onNextStep = () => {
    const distributionKeys = this.state.distributionKeys;
    if (this.props.state.address.units.length === 1) {
      distributionKeys[this.props.state.address.units[0].id] = 100;
    }

    // if all distribution keys are not set then show error
    if (
      this.props.state.address.units.reduce((acc, unit) => {
        return acc + (distributionKeys[unit.id] ?? 0);
      }, 0) === 0
    ) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          distributionKeys: this.trans(
            "coach/new-bill-settlement/steps/unit/section-two/distribution-key/error/not-set"
          ),
        },
      });
      return;
    }

    // if any distribution key is not between 0 and 100 then show error
    if (
      this.props.state.address.units.some(
        (unit) =>
          Number(distributionKeys[unit.id]) < 0 ||
          Number(distributionKeys[unit.id]) > 100
      )
    ) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          distributionKeys: this.trans(
            "coach/new-bill-settlement/steps/unit/section-two/distribution-key/error/not-in-range"
          ),
        },
      });
      return;
    }

    this.setState({
      ...this.state,
      loading: true,
    });

    this.props.setState({
      ...this.props.state,
      ...this.state,
      distributionKeys,
      unit_calculations: this.doUnitCalculations(),
      activeStep: 3,
    });
  };

  public onBack = () => {
    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 1,
    });
  };

  public render() {
    return (
      <div className="coach_newBillSettlement_step_wrapper">
        <div className="coach_newBillSettlement_step_title">
          {this.props.state.address?.displayName ?? ""}
        </div>
        <BillDetails {...this.props} />
        <div className="coach_newBillSettlement_step_section">
          <div className="coach_newBillSettlement_step_section_header">
            <div className="coach_newBillSettlement_step_section_header_title">
              {this.trans(
                "coach/new-bill-settlement/steps/unit/section-two/title"
              )}
            </div>
          </div>

          {/*** list of distribution key fields ***/}

          <div className="coach_newBillSettlement_step_section_content" style={{width:'60%'}}>
                <List style={{paddingTop:0, paddingBottom:0}}>
                  {this.props?.state?.address?.units?.length === 1 ? (
                    <ListItemText
                      primary={this.trans(
                        "coach/new-bill-settlement/steps/unit/section-two/one-unit-only-message"
                      )}
                    />
                  ) : (
                    this.props.state.address.units.map((unit, idx, arr) => {
                      const distributionKeys = this.state.distributionKeys;
                      const totalDistributionKeys = arr.reduce((acc, unit) => {
                        return acc + (distributionKeys[unit.id] ?? 0);
                      }, 0);
                      const percentage =
                        totalDistributionKeys === 0 ||
                        isNaN(totalDistributionKeys) ||
                        !distributionKeys[unit.id]
                          ? 0
                          : (Number(distributionKeys[unit.id]) ?? 0) /
                            Number(totalDistributionKeys);

                      const distributedAmount =
                        totalDistributionKeys === 0 ||
                        isNaN(totalDistributionKeys) ||
                        !distributionKeys[unit.id]
                          ? 0
                          : this.props.state.bill_calculations
                              .total_settled_amount * percentage;

                      // const percentage = (distributionKeys[unit.id] ?? 0) * 100 / totalDistributionKeys;
                      return (
                        <div className="coach_newBillSettlement_step_section_content_item">
                        <ListItem 
                          key={idx}                             
                          disableGutters={true}
                          style={{paddingTop:0, paddingBottom:0, width:'60%'}}
                        >
                          <ListItemText
                            primary={<Typography variant="body2" style={{fontWeight: 'bold'}}>{`${this.trans("coach/new-bill-settlement/steps/unit/section-two/unit-number")}: ${unit.unitNumber}`}</Typography>}                         
                            secondary={<Typography variant="body2">{unit.type.label}</Typography>}
                          />
                          <ListItemText
                            primary={<Typography variant="body2" style={{fontWeight: 'bold'}}>{distributedAmount.toFixed(2) + 'EUR'}</Typography>}
                            secondary={<Typography variant="body2">{(percentage * 100).toFixed(2) + "%"}</Typography>}
                          />
                          <ListItemSecondaryAction>
                            <TextField
                              style={{fontSize: '14px'}}
                              label={this.trans(
                                "coach/new-bill-settlement/steps/unit/section-two/distribution-key/label"
                              )}
                              error={
                                Number(distributionKeys[unit.id]) < 0 ||
                                Number(distributionKeys[unit.id]) > 100
                              }
                              type="number"
                              value={distributionKeys[unit.id] || ""}
                              onChange={(e) => {
                                if (!Number.isInteger(Number(e.target.value)))
                                  return;

                                this.update_unit_distribution_key(
                                  unit.id,
                                  Number(e.target.value)
                                );
                              }}
                            />
                          </ListItemSecondaryAction>
                        </ListItem>
                        </div>
                      );
                    })
                  )}
                </List>
              
              {/*** error message for distribution keys ***/}

              {this.state.errors.distributionKeys ? (
                <div className="coach_newBillSettlement_step_section_content_item_row">
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.distributionKeys}
                  </div>
                </div>
              ) : null}

             {/*** hint text ***/}

             {this.props?.state?.address?.units?.length === 1 ? null : (
               <div className="coach_newBillSettlement_step_section_content_item_row">
                  <div className="coach_newBillSettlement_step_section_content_item_row_hint">
                    {this.trans("coach/new-bill-settlement/steps/unit/section-two/hint")}             
                  </div>
                </div>
              )}

          </div>
        </div>
        
        {/*** Next/Previous buttons ***/}

        <div className="coach_newBillSettlement_actionButtons">
          <Button
            variant="contained"
            onClick={this.onBack}
            startIcon={<ArrowBackIos />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/back")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onNextStep}
            disabled={this.state.loading || this.state.isNextDisabled}
            endIcon={<ArrowForwardIosIcon />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/next")}
          </Button>
        </div>
        
      </div>
    );
  }
}

export default Unit;
